import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';
import Checkbox from '../Checkbox';
import UploadProgressBar from '../UploadProgressBar';
import { formatBytes } from '../../../utils/upload_helpers';
import successUpload from '../../../../assets/images/icons/share/filled@2x.png';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const TrackFileUpload = ({ file, removeFile, handleCheckboxChange, smoothFile, progress, uploaded, uploading }) => {
  const memoRemoveFile = useCallback(() => {
    removeFile(file);
  }, [file]);

  return (
    <div className={styles.container}>
      <div className={styles.checkboxAndFiletype}>
        {uploaded && <img src={successUpload} alt="success" className={styles.successUpload} />}
        <div className={styles.fileType}>{file.type || 'GPX'}</div>
      </div>
      <div className={styles.fileInformation}>
        <div className={styles.metaData}>
          <div className={styles.fileName}>{file.name}</div>
          <UploadProgressBar progress={progress} />
          <div className={styles.fileSize}>
            {StringConstantsMixin.strings.CONVERTER.FILE_SIZE}: {formatBytes(file.size)}
          </div>
        </div>
        <div className={styles.controls}>
          <button onClick={memoRemoveFile} type="button" className={styles.removeButton}>
            {StringConstantsMixin.strings.CONVERTER.REMOVE_FILE}
          </button>
          <div>
            <Checkbox
              label={StringConstantsMixin.strings.SMOOTH_FILE}
              name="smooth-file"
              checked={smoothFile}
              disabled={uploaded || uploading}
              handleChange={handleCheckboxChange}
              labelClassName={styles.labelClassName}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

TrackFileUpload.propTypes = {
  file: PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.number
  }).isRequired,
  removeFile: PropTypes.func,
  handleCheckboxChange: PropTypes.func,
  smoothFile: PropTypes.bool,
  progress: PropTypes.number,
  uploaded: PropTypes.bool,
  uploading: PropTypes.bool
};

TrackFileUpload.defaultProps = {
  removeFile: () => {},
  handleCheckboxChange: () => {},
  smoothFile: true,
  progress: 0,
  uploaded: false,
  uploading: false
};

export default TrackFileUpload;
